import { render, staticRenderFns } from "./RedWhite.vue?vue&type=template&id=a84a7170&"
import script from "./RedWhite.vue?vue&type=script&lang=js&"
export * from "./RedWhite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports